export const galleria = {
    thumbnailContainer: {
        className: 'p-0 relative mt-2'
    },
    previousThumbnailButton: {
        className: 'h-[35px] w-[35px] absolute left-0 top-1/2 -translate-y-1/2 z-10 cursor-pointer'
    },
    nextThumbnailButton: {
        className: 'h-[35px] w-[35px] absolute right-0 top-1/2 -translate-y-1/2 z-10 cursor-pointer'
    },
    thumbnailitemcontent: {
        className: 'px-1'
    },
    thumbnailitems: {
        className: '-mx-2 flex'
    },
    mask: {
        className: 'border border-red'
    }
}